<template>
  <!-- header START -->
  <div class="header">

    <!-- col-1 start -->
    <div class="col-1">

      <!-- button-weeks start -->
      <div class="button-weeks" v-if="$store.state.game">

        <div v-show="$store.state.game.Week != 1"><!-- +/- class darkgreen -->
          <span class="week">{{$t('week')}}</span>
          <span class="number">{{$store.state.game.Week - 1}}</span>
        </div>

        <div class="darkgreen"><!-- +/- class darkgreen -->
          <span class="week">{{$t('week')}}</span>
          <span class="number">{{$store.state.game.Week}}</span>
        </div>

        <div><!-- +/- class darkgreen -->
          <span class="week">{{$t('week')}}</span>
          <span class="number">{{getWeek($store.state.game.Week, 1)}}</span>
        </div>

        <div><!-- +/- class darkgreen -->
          <span class="week">{{$t('week')}}</span>
          <span class="number">{{getWeek($store.state.game.Week, 2)}}</span>
        </div>

        <div><!-- +/- class darkgreen -->
          <span class="week">{{$t('week')}}</span>
          <span class="number">{{getWeek($store.state.game.Week, 3)}}</span>
        </div>

      </div>
      <!-- button-weeks stop -->

      <!-- start -->
      <div class="counterTime" v-on="countDownTimer()" v-if="game">
        <div>0</div>
        <div>{{game.time.min[0]}}</div>
        <i>:</i>
        <div>{{game.time.sec.length == 2 ? game.time.sec[0] : 0}}</div>
        <div>{{game.time.sec.length == 2 ? game.time.sec[1] : game.time.sec[0]}}</div>
      </div>
      <!-- stop -->

    </div>
    <!-- col-1 stop -->

    <!-- col-2 start -->
    <div class="col-2">

      <!-- jackpot start -->
      <div class="jackpotBox">
        <img src="@/assets/images/jackpot.svg" alt="" />
        <div class="jackpotNumber" v-if="$store.state.jackpot">{{$store.state.jackpot.Amount.toFixed(2)}}</div>
      </div>
      <!-- jackpot stop -->

      <!-- hb2 start -->
      <div class="hb2">
        <div class="user">
          <img src="@/assets/images/user.svg" alt="" />:
          <span>{{$store.state.user.User}}</span>
        </div>
        <div class="business-and-finance">
          <img src="../assets/images/business-and-finance.png" alt="" />
          <span>{{$store.state.user.profit.toFixed(2)}} {{$store.state.user.Currency}}</span>
          </div>
        <div class="dollar">
          <img src="@/assets/images/dollar.svg" alt="" />
          <span>{{$store.state.user.Balance.toFixed(2)}} {{$store.state.user.Currency}}</span>
        </div>
      </div>
      <!-- hb2 stop -->

    </div>
    <!-- col-2 stop -->

  </div>
  <!-- header STOP -->
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'Stats',
  data: function(){
    return {
      lang: 'en'
    }
  },
  timer: 0,
  created: function () {
    document.addEventListener('visibilitychange', () => {
      if(document.visibilityState == 'visible'){
        if(Date.now() - this.$store.state.lastActiveTime > 180000) this.$store.dispatch('apirequest', {token: this.$store.state.user.id, name: "game/kass"}).then((response) => {
            this.$store.state.Time = (this.$store.state.game.Time - Date.now()) / 1000;
          });
        this.$store.state.lastActiveTime = null;
      }
      if(document.visibilityState == 'hidden'){
        //remember when tab was deactivated
        this.$store.state.lastActiveTime = Date.now();
      }
      if(document.visibilityState == 'unloaded'){
        //browser tab was unloaded from memory, reset is needed
      }
    }, false);
    
  },
  destroyed() {
      clearInterval(this.$options.timer);
    },
  computed: {
    game: function(){
      if(!this.$store.state.game) return
      var game = { time: {min: '', sec: ''}, count: ''};
      game.time.min = Math.floor(this.$store.state.Time / 60);
      game.time.sec = Math.floor(this.$store.state.Time) - game.time.min * 60;
      game.count = this.$store.state.Time;
      game.time.min = game.time.min.toString();
      game.time.sec = game.time.sec.toString();
      return game;  
    }
  },
  methods: {
    countDownTimer() {
      if(!this.$store.state.game) return
        if( this.$store.state.Time > 0) {
          if(!this.$options.timer){
            this.$options.timer = setInterval(async () => {
              this.$store.state.Time =( (this.$store.state.game.Time - Date.now()) / 1000 );
            }, 1000)
          }
        }else{
          this.$store.dispatch('apirequest', {token: this.$store.state.user.id, name: "game/kass"}).then((response) => {
            this.$store.state.Time = ((this.$store.state.game.Time - Date.now()) / 1000);
          });
          this.$store.state.Bets = [];
          this.$store.state.total = 0;
        }
    },
    getWeek(week, pos){
      if(week == 38){
        if(pos == 1) return 1
        if(pos == 2) return 2
        if(pos == 3) return 3
      }
      if(week == 37){
        if(pos == 1) return 38
        if(pos == 2) return 1
        if(pos == 3) return 2
      }
      if(week == 36){
        if(pos == 1) return 37
        if(pos == 2) return 38
        if(pos == 3) return 1
      }
      if(week < 36){
        return week+pos
      }
    }    
  },
  watch: {
    game: function(){
      
    }
  }
};
</script>-->
